export default {"src":"/_next/static/media/time-consuming.76503678.svg","height":60,"width":54,"blurWidth":0,"blurHeight":0};